class CartDrawer extends HTMLElement {
    constructor() {
      super();
  
      this.notification = document.getElementById('cart-drawer');
      this.notificationSuccess = this.querySelector('.cart-drawer__success');
  
      this.button = document.getElementById('cart-icon-bubble');
      this.header = document.querySelector('sticky-header');
      this.onBodyClick = this.handleBodyClick.bind(this);
      this.shippingCosts = this.querySelector('cart-shipping-costs');
      
      this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      
      this.init();
    }
  
    init() {
      this.querySelectorAll('button[type="button"].cart-drawer__close').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    }
  

  open() {
      this.classList.add('animate', 'active');
      this.classList.add('active');
      this.button.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
      if (this.shippingCosts) {
        //this.shippingCosts.init();
        this.shippingCosts.calculateShippingCosts();
      }
  
  
  
      this.addEventListener('transitionend', () => {
        this.focus();
        trapFocus(this);
      }, { once: true });
  
      document.body.addEventListener('click', this.onBodyClick);
    }
  
  close() {
    console.log('close');
      this.notification.classList.remove('active');
      this.classList.remove('active');
      this.button.classList.remove('active');
      if (this.notificationSuccess) this.notificationSuccess.classList.add('hidden');
  
  
  
  
      document.body.removeEventListener('click', this.onBodyClick);
      document.body.classList.remove('overflow-hidden');
  
    removeTrapFocus(this.activeElement);
    this.closeEditDialogs();
  }
  
  closeEditDialogs() {
    const allDialogs = document.querySelectorAll('edit-dialog[open]');
    allDialogs.forEach((dialog) => {
        dialog.hide();
    });
  }
  
    renderContents(parsedState) {
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });
      if (this.header) this.header.reveal();
      setTimeout(() => {

        this.open();
        this.init();
        this.showSuccessMessage();
        window.changeCalendlyLinks();
      });

    }
  
  showSuccessMessage() {
    this.notificationSuccess = this.querySelector('.cart-drawer__success');
    if (this.notificationSuccess) this.notificationSuccess.classList.remove('hidden');
    setTimeout(() => { this.notificationSuccess.classList.add('hidden'); }, 5000);


  }
  
  
    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '.drawer__inner',
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
      }
  
  
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  
    handleBodyClick(evt) {
      const target = evt.target;
      if (target !== this.notification && target !== this.button  && !target.closest('cart-drawer')  && !target.closest('modal-dialog')) {
        const disclosure = target.closest('details-disclosure');
        this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
        this.close();
      }
    }
  
    setActiveElement(element) {
      this.activeElement = element;
    }
  }
  
  customElements.define('cart-drawer', CartDrawer);

  if (!customElements.get('cart-vat-details')) {
    class CartVatDetails extends HTMLElement {
      connectedCallback() {
        const vatDetails = this.querySelector('details.cart-drawer__vat');
        if (!vatDetails) return;

        const getCheckoutForm = () => {
          const footer = this.closest('.cart-drawer__footer');
          if (!footer) return null;

          const exemptifyButton = footer.querySelector('.exemptify_button,[name="checkout-exemptify"]');
          if (exemptifyButton) return exemptifyButton.closest('form');

          const originalCheckoutButton = footer.querySelector('button[type="submit"][name="checkout"]');
          if (originalCheckoutButton) return originalCheckoutButton.closest('form');

          return footer.querySelector('form');
        };

        const syncCheckoutButtons = () => {
          const form = getCheckoutForm();
          if (!form) return;

          const originalCheckoutButton = form.querySelector('button[type="submit"][name="checkout"]');
          const exemptifyButton = form.querySelector('.exemptify_button,[name="checkout-exemptify"]');

          if (!vatDetails.open) {
            if (originalCheckoutButton) originalCheckoutButton.style.removeProperty('display');
            if (exemptifyButton) exemptifyButton.style.display = 'none';
            return;
          }

          if (!exemptifyButton) {
            if (originalCheckoutButton) originalCheckoutButton.style.removeProperty('display');
            return;
          }

          if (originalCheckoutButton) originalCheckoutButton.style.display = 'none';
          exemptifyButton.style.removeProperty('display');
        };

        const observeCheckoutButtons = () => {
          const form = getCheckoutForm();
          if (!form || form.dataset.exemptifyObserverBound) return;

          const observer = new MutationObserver(() => syncCheckoutButtons());
          observer.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
          form.dataset.exemptifyObserverBound = 'true';
        };

        if (!vatDetails.dataset.vatInputsBound) {
          vatDetails.addEventListener('toggle', () => {
            syncCheckoutButtons();
          });
          vatDetails.dataset.vatInputsBound = 'true';
        }

        observeCheckoutButtons();
        syncCheckoutButtons();
      }
    }

    customElements.define('cart-vat-details', CartVatDetails);
  }
  
  
  class CartLink extends HTMLElement {
    constructor() {
      super();
  
      this.cartNotification = document.querySelector('cart-drawer');
      if (this.cartNotification) {
         
        this.addEventListener('click', (event) => {
          event.preventDefault();
          if (this.cartNotification.header) this.cartNotification.header.reveal();
          this.cartNotification.open();
        });
      }
    }
  
  }
  
  customElements.define('cart-link', CartLink);
  
  if (!customElements.get('cart-drawer-items')) {
  
  
    class CartNotificationItems extends HTMLElement {
      constructor() {
        super();
  
        this.lineItemStatusElement = document.getElementById('cart-drawer-shopping-cart-line-item-status');
  
        this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
          .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
  
        this.debouncedOnChange = debounce((event) => {
          this.onChange(event);
        }, 300);
  
        this.addEventListener('change', this.debouncedOnChange.bind(this));
  
      }
  
      onChange(event) {
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target);
      }
  
      getSectionsToRender() {
        return [
          {
            id: 'CartDrawer',
            section: 'cart-drawer',
            selector: '.cart-drawer',
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
        ];
      }
  
      addProduct(id, quantity) {
        const body = JSON.stringify({
          id,
          quantity,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        });
  
        fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            this.classList.toggle('is-empty', parsedState.item_count === 0);
            const cartFooter = document.getElementById('main-cart-footer');
            const cartItems = document.getElementById('main-cart-items');
  
            if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
  
            this.getSectionsToRender().forEach((section => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          
              elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
  
          
            }));
            cartItems.scrollIntoView();
  
  
            this.disableLoading();
          }).catch((e) => {
            console.log(e);
            this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
            document.getElementById('notification-cart-errors').textContent = window.cartStrings.error;
            this.disableLoading();
          });
      }


  
      updateQuantity(line, quantity, name, input) {
        this.max = input.max;      
        if (this.max) {
          if (quantity > input.max) {
            document.getElementById(`Line-item-error-${line}`)
              .querySelector('.notification-cart-item__error-text')
              .innerHTML = window.cartStrings.quantityError.replace(
                '[quantity]',
                input.max
              );
            quantity = input.max;
          }
        }
        
        this.enableLoading(line);
  
  
        const body = JSON.stringify({
          line,
          quantity,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
        });
  
  
        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            this.classList.toggle('is-empty', parsedState.item_count === 0);
            const cartFooter = document.getElementById('main-cart-footer');
  
            if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
  
            this.getSectionsToRender().forEach((section => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
  
              elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }));
  
            this.updateLiveRegions(line, parsedState.item_count);
            const lineItem = document.getElementById(`CartItem-${line}`);
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
            this.disableLoading();
            document.querySelector('cart-drawer').init();
            

          }).catch((e) => {
            console.log(e);
            this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
            document.getElementById('notification-cart-errors').textContent = window.cartStrings.error;
            this.disableLoading();
          });
      }
  
      updateLiveRegions(line, itemCount) {
        // console.log(line);
        // if (this.currentItemCount === itemCount) {
        //   document.getElementById(`Line-item-error-${line}`)
        //     .querySelector('.notification-cart-item__error-text')
        //     .innerHTML = window.cartStrings.quantityError.replace(
        //       '[quantity]',
        //       document.getElementById(`Quantity-${line}`).value
        //     );
        // }
  
        this.currentItemCount = itemCount;
        this.lineItemStatusElement.setAttribute('aria-hidden', true);
  
        const cartStatus = document.getElementById('cart-drawer-cart-live-region-text');
        cartStatus.setAttribute('aria-hidden', false);
  
        setTimeout(() => {
          cartStatus.setAttribute('aria-hidden', true);
        }, 1000);
      }
  
      getSectionInnerHTML(html, selector) {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector).innerHTML;
      }
  
      enableLoading(line) {
        line = line + 1;
        document.getElementById('cart-drawer').classList.add('cart__items--disabled');
        this.querySelectorAll(`#cart-drawer-product-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
        document.activeElement.blur();
        this.lineItemStatusElement.setAttribute('aria-hidden', false);
      }
  
      disableLoading() {
        document.getElementById('cart-drawer').classList.remove('cart__items--disabled');
      }
    }
  
    customElements.define('cart-drawer-items', CartNotificationItems);
    
  }
  
  class NotificationCartRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault();
        this.closest('cart-drawer-items').updateQuantity(this.dataset.index, 0, document.activeElement.getAttribute('name'), event.target);
      });
    }
  }
  
  customElements.define('notification-cart-remove-button', NotificationCartRemoveButton);

  if (!customElements.get('cart-addon-add-button')) {
    class CartAddonAddButton extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.onClick.bind(this));
      }

      async onClick(event) {
        event.preventDefault();
        if (this.getAttribute('aria-disabled') === 'true') return;

        const cartItems = this.closest('cart-drawer-items');
        if (!cartItems) return;

        const id = Number(this.dataset.id);
        const quantity = Number(this.dataset.quantity) || 1;
        const parentVariant = Number(this.dataset.parentVariant);
        const parentKey = this.dataset.parentKey;
        const parentQuantity = Number(this.dataset.parentQuantity) || 1;
        if (!id || !parentVariant || !parentKey) return;

        let parentProperties = {};
        try {
          parentProperties = JSON.parse(this.dataset.parentProperties || '{}');
        } catch (error) {
          parentProperties = {};
        }

        const button = this.querySelector('button');
        this.setAttribute('aria-disabled', 'true');
        this.classList.add('loading');
        if (button) button.classList.add('loading');
        const spinner = this.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const sections = cartItems.getSectionsToRender().map((section) => section.section);
        const sections_url = window.location.pathname;
        const parentItem = {
          id: parentVariant,
          quantity: parentQuantity,
        };

        if (parentProperties && Object.keys(parentProperties).length) {
          parentItem.properties = parentProperties;
        }

        if (this.dataset.parentSellingPlan) {
          parentItem.selling_plan = Number(this.dataset.parentSellingPlan);
        }

        const renderSections = (parsedState) => {
          cartItems.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });

          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) cartDrawer.init();
        };

        try {
          const changeResponse = await fetch(`${routes.cart_change_url}`, {
            ...fetchConfig(),
            body: JSON.stringify({
              id: parentKey,
              quantity: 0,
            }),
          });
          const changeState = await changeResponse.json();

          if (changeState.status || changeState.errors) {
            throw new Error(changeState.description || changeState.message || changeState.errors);
          }

          const addResponse = await fetch(`${routes.cart_add_url}`, {
            ...fetchConfig(),
            body: JSON.stringify({
              items: [
                parentItem,
                {
                  id,
                  quantity,
                  parent_id: parentVariant,
                },
              ],
              sections,
              sections_url,
            }),
          });
          const parsedState = await addResponse.json();

          if (parsedState.status || parsedState.errors) {
            await fetch(`${routes.cart_add_url}`, {
              ...fetchConfig(),
              body: JSON.stringify({
                items: [parentItem],
                sections,
                sections_url,
              }),
            })
              .then((response) => response.json())
              .then((restoreState) => {
                if (restoreState.sections) renderSections(restoreState);
              });

            throw new Error(parsedState.description || parsedState.message || parsedState.errors);
          }

          renderSections(parsedState);
        } catch (error) {
          console.error(error);
        } finally {
          this.classList.remove('loading');
          if (button) button.classList.remove('loading');
          this.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        }
      }
    }

    customElements.define('cart-addon-add-button', CartAddonAddButton);
  }

  class NotificationCartClearButton extends HTMLElement {
    constructor() {
      super();
      const anchor = this.querySelector('a');
      if (anchor) {
        anchor.addEventListener('click', (event) => {
          event.preventDefault();
          const confirmationMessage = anchor.getAttribute('data-confirmation-message');
          if (confirmationMessage && confirm(confirmationMessage)) {
            this.emptyCart();
          }
        });
      }


    }

    emptyCart() {

      const cartDrawer = this.closest('cart-drawer').querySelector('cart-drawer-items');
  
  
  
        const body = JSON.stringify({
          sections: cartDrawer.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
        });
      
  
  
        fetch(`${routes.cart_url}/clear`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            cartDrawer.classList.toggle('is-empty', parsedState.item_count === 0);
            const cartFooter = document.getElementById('main-cart-footer');
  
            if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
  
            cartDrawer.getSectionsToRender().forEach((section => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
  
              elementToReplace.innerHTML =
              cartDrawer.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }));
  
            document.querySelector('cart-drawer').init();            
  
          }).catch((e) => {
            console.log(e);
            cartDrawer.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
            document.getElementById('notification-cart-errors').textContent = window.cartStrings.error;
            cartDrawer.disableLoading();
          });
    }
  }

  customElements.define('notification-cart-clear-button', NotificationCartClearButton);

  class EditDialog extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[id^="ModalClose-"]').addEventListener('click', (event) => this.hide(event, false));
      this.addEventListener('keyup', (event) => {
        if(!event.code) return;
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
      if (this.classList.contains('media-modal')) {
        this.addEventListener('pointerup', (event) => {
          if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model, modal-thumbnails')) this.hide(event);
        });
      } else {
        this.addEventListener('click', (event) => {
          if (event.target === this) this.hide(event);
        });
      }


    }
  
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      this.originalContent = this.innerHTML;
      document.querySelector('.cart-drawer').appendChild(this);
    }
  
    show(opener) {
      this.closeAllOtherDialogs(); // Close all other dialogs before showing this one

      this.openedBy = opener;
      const popup = this.querySelector('.template-popup');
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
      if (popup) popup.loadContent();
      const dynamicContent = this.querySelector('.dynamic-content');
      if (dynamicContent) dynamicContent.fetchContent(dynamicContent.dataset.url);
      trapFocus(this, this.querySelector('[role="dialog"]'));
      window.pauseAllMedia();
    }
  
    hide(event) {
      if (event) {
        event.stopPropagation();
      }
      console.log('hide: edit-dialog')
      document.body.classList.remove('overflow-hidden');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      this.removeAttribute('open');
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia();
      this.removeContentFromDialog();
  
    }

    removeContentFromDialog() {
        if (this.originalContent) {
          this.innerHTML = this.originalContent;
          this.querySelector('[id^="ModalClose-"]').addEventListener(
            'click',
            (event) => this.hide(event, false)
          );
        }
    }

    closeAllOtherDialogs() {
      // Close all other EditDialog elements on the page
      const allDialogs = document.querySelectorAll('edit-dialog[open]');
      allDialogs.forEach((dialog) => {
        if (dialog !== this) {
          console.log('close: edit-dialog')
          dialog.hide();
        }
      });
    }
  }
customElements.define('edit-dialog', EditDialog);
  
class EditOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      console.log('click: edit-opener')
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('edit-opener', EditOpener);

